import './ServiceBlock.sass';

const ServiceBlock = (props) => {
    let imageOrder = 0;
    let textImage = '';
    if (props.imageRight) {
        imageOrder = 1;
        textImage = ' text-image';
    }
    let className = '';
    if (props.className) className += ' ' + props.className;

    return (
        <article className={'service-block' + className + textImage}>
            <div className='' style={{order: imageOrder}}>
                {props.image && <img src={props.image} alt='' /> }
                {props.video && (
                    <video autoPlay loop muted playsInline>
                        <source src={props.video} type="video/mp4"/>
                    </video>
                )}
            </div>
            <div className='d-flex align-items-center' style={{order: 0}}>
                <div>
                    <h1>{props.header}</h1>
                    <p>{props.description}</p>
                    <div className='service-block__hashtags'>
                        {props.children}
                    </div>
                </div>
            </div>
        </article>
    );
};

export default ServiceBlock;